import { TRUCKER_PROFILE_URL } from '@/constants';
import { HttpStatusCode, fromRiskBff, httpClient } from '@/utils';
import { LoadTruckerProfileByIdServicePayload, LoadTruckerProfileByIdServiceResult } from './types';
import { parseResultToFormTrucker, validateFormTruckerData } from '@/services/utils';
import { ForbiddenError, NotFoundError, UnauthorizedError, UnexpectedError } from '@/services/errors';
import { FormTrucker } from '@/types';

const getParsedFormTruckerOrThrowError = ({ data }: LoadTruckerProfileByIdServiceResult): FormTrucker => {
  try {
    const formTrucker = parseResultToFormTrucker(data);
    if (!formTrucker.cpf) throw new NotFoundError();
    return validateFormTruckerData(formTrucker);
  } catch (error) {
    if (error instanceof NotFoundError) throw error;
    throw new UnexpectedError();
  }
};

export const loadTruckerProfileByIdService = async (
  data: LoadTruckerProfileByIdServicePayload,
): Promise<FormTrucker> => {
  const uri = fromRiskBff(`${TRUCKER_PROFILE_URL}/${data.truckerId}`);
  const { status, body } = await httpClient.get<LoadTruckerProfileByIdServiceResult>(uri);

  switch (status) {
    case HttpStatusCode.ok:
      return getParsedFormTruckerOrThrowError(body);

    case HttpStatusCode.notFound:
      throw new NotFoundError();

    case HttpStatusCode.unauthorized:
      throw new UnauthorizedError();

    case HttpStatusCode.forbidden:
      throw new ForbiddenError();

    default:
      throw new UnexpectedError();
  }
};
